import React from "react";
import { Box, Typography, Button, Grid, Stack } from "@mui/material";
import Img from "./priceImg.png"; // Replace with your image path

const Accordion3SubSection = () => {
  return (
    <Stack
      sx={{
        // backgroundColor: "#f9f9f9",
        padding: "20px",
        borderRadius: "10px",
        // boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
        width: "100%",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "center", sm: "flex-start" },
      }}
    >
      <Box
        sx={{
          flex: 1,
          maxWidth: { xs: "100%", sm: "60%" },
          textAlign: { xs: "center", sm: "left" },
          marginBottom: { xs: "20px", sm: "0" },
        }}
      >
        {/* <Typography
          variant="h5"
          sx={{ fontWeight: "bold", color: "#333", marginBottom: "10px" }}
        >
          Enterprise <span style={{ color: "#4caf50" }}>Custom Plans</span>
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "#666", marginBottom: "20px" }}
        >
          If you don't find a suitable plan for you, don't worry. We offer
          tailored plans according to your requirements, with enterprise-grade
          features as below:
        </Typography> */}
        <Grid
          container
          spacing={2}
          sx={{
            marginBottom: "20px",
          }}
        >
          {[
            "Custom development by Picky Assist engineers",
            "Dedicated Customer Success Manager",
            "Free monthly discovery calls",
            "Fully managed setup, integrations and onboarding",
            "Employees training",
            "Access to CEO, CTO, CSO team",
            "Priority Telephonic Support",
            "Free Mini App development",
            "Tailormade Limits",
            "Sign Sign On (SSO)",
            "Access Controls",
          ].map((feature, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  padding: "10px 15px",
                  borderRadius: "20px",
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                <Box
                  sx={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: "#4caf50",
                    marginRight: "10px",
                  }}
                />
                <Typography sx={{ fontSize: "14px", color: "#333" }}>
                  {feature}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Typography
          sx={{ color: "#999", marginBottom: "20px", textAlign: "center" }}
        >
          Enterprise custom plans are offered only for yearly commitment where
          contract value should be more than{" "}
          <span style={{ color: "#4caf50", fontWeight: "bold" }}>$5000</span>{" "}
          for a year
        </Typography>
        <Button
          variant="contained"
          color="warning"
          sx={{
            padding: "10px 20px",
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: "bold",
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: "-100%",
              width: "100%",
              height: "100%",
              background:
                "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
              transform: "skewX(-45deg)",
              animation: "lightSweep 2s infinite", // Add animation
            },
          }}
        >
          Book an Appointment →
        </Button>
      </Box>
      <Box
        sx={{
          flex: 1,
          maxWidth: { xs: "100%", sm: "40%" },
          textAlign: "center",
        }}
      >
        <img
          src={Img}
          alt="City Illustration"
          style={{
            width: "100%",
            maxWidth: "300px",
            margin: "auto",
            display: "block",
          }}
        />
      </Box>

      {/* Add the keyframes animation */}
      <style>
        {`
          @keyframes lightSweep {
            0% {
              left: -100%;
            }
            50% {
              left: 50%;
            }
            100% {
              left: 100%;
            }
          }
        `}
      </style>
    </Stack>
  );
};

export default Accordion3SubSection;
